import { render } from "./materialPreparation.vue?vue&type=template&id=2b49cdd6&scoped=true"
import script from "./materialPreparation.vue?vue&type=script&lang=js"
export * from "./materialPreparation.vue?vue&type=script&lang=js"

import "./materialPreparation.vue?vue&type=style&index=0&id=2b49cdd6&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b49cdd6"]])

export default __exports__